<template>
    <div>
        <n-card style="width: 85%; height: 88vh; border: 1px;position:fixed;">
        <iframe src="https://share.fastgpt.in/chat/share?shareId=0iags44jjpml7pdxacicptlt" style="width: 100%; height: 100%; border: 0.01px;"></iframe>
        </n-card>
    </div>
</template>

<script>

</script>

<style>
</style>